export default "__VITE_ASSET__75040bc4__"